/**
 * Spam Token送金判定用Token Transfer件数キャッシュの現行Version。
 *
 * チェーンごとの計数仕様を変更した場合は、対応する値だけを更新する。
 */
export const tokenTransferCountVersion = {
  evm: 1,
  solana: 1,
} as const
